export default "__VITE_ASSET__Dn6Ol0cI__"